import * as React from 'react';
export const IcAtHomeHazard = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M22 10.07a1.53 1.53 0 00-.48-.76L13.85 2.7a2.79 2.79 0 00-3.7 0L2.53 9.31A1.53 1.53 0 002.08 11c.098.29.283.54.53.72.242.187.535.295.84.31H4v7a3 3 0 003 3h10a3 3 0 003-3V12h.55a1.49 1.49 0 00.84-.31c.247-.18.432-.43.53-.72a1.54 1.54 0 00.08-.9zM11 7a1 1 0 112 0v6a1 1 0 01-2 0V7zm2.06 11.56a1.5 1.5 0 01-2.45-.49 1.49 1.49 0 01-.08-.86A1.49 1.49 0 0111.71 16a1.49 1.49 0 01.86.08 1.5 1.5 0 01.49 2.45v.03z'
      fill='currentColor'
    />
  </svg>
);
